export default Object.freeze({
	COMPANY: 'company',
	TRUST: 'trust',
	TAXI: 'taxi',
});
